import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box } from '@honda-canada/design-system-react';
import themeStyles from '../styles/LoyaltyOfferFilters.styles';
import SortBy from './SortBy';
import GeoLocator from './GeoLocator';
const RegionAndSortContainer = themeStyles.apply(Box, 'RegionAndSortContainer');
const OfferRegionWrapper = themeStyles.apply(Box, 'OfferRegionWrapper');
const RegionAndSort = ({ isLoyaltyFilterVisible = false, sortOptions }) => (_jsxs(RegionAndSortContainer, { isLoyaltyFilterVisible: isLoyaltyFilterVisible, children: [_jsx(OfferRegionWrapper, { children: _jsx(GeoLocator, {}) }), _jsx(SortBy, { options: sortOptions })] }));
export default RegionAndSort;
